(function () {
  const transitionDuration = "400ms";
  const transitionType = "ease-in-out";
  const supportsInert = "inert" in HTMLElement.prototype;
  const FOCUSABLE_SELECTOR =
    'a[href], button, input, textarea, select, details, [tabindex]';

  const lockFocus = (answer) => {
    if (!answer) return;

    if (supportsInert) {
      answer.inert = true;
      return;
    }

    answer.setAttribute("aria-hidden", "true");
    answer.querySelectorAll(FOCUSABLE_SELECTOR).forEach((el) => {
      if (el.hasAttribute("tabindex")) {
        el.setAttribute("data-inert-tabindex", el.getAttribute("tabindex"));
      } else {
        el.setAttribute("data-inert-tabindex", "");
      }
      el.setAttribute("tabindex", "-1");
    });
  };

  const unlockFocus = (answer) => {
    if (!answer) return;

    if (supportsInert) {
      answer.inert = false;
      return;
    }

    answer.removeAttribute("aria-hidden");
    answer.querySelectorAll("[data-inert-tabindex]").forEach((el) => {
      const original = el.getAttribute("data-inert-tabindex");
      if (original) {
        el.setAttribute("tabindex", original);
      } else {
        el.removeAttribute("tabindex");
      }
      el.removeAttribute("data-inert-tabindex");
    });
  };

  const slideUp = (element) => {
    if (!element) return;
    const height = element.getBoundingClientRect().height;

    element.style.height = `${height}px`;
    element.style.overflow = "hidden";
    element.style.transition = `height ${transitionDuration} ${transitionType}, opacity ${transitionDuration} ${transitionType}`;

    void element.offsetHeight;

    element.style.height = "0";
    element.style.opacity = "0";

    const cleanup = () => {
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
      element.removeEventListener("transitionend", cleanup);
    };

    element.addEventListener("transitionend", cleanup);
  };

  const slideDown = (element) => {
    if (!element) return;

    element.style.removeProperty("display");
    let display = window.getComputedStyle(element).display;
    if (display === "none") display = "block";
    element.style.display = display;

    const height = element.scrollHeight;

    element.style.height = "0";
    element.style.opacity = "0";
    element.style.overflow = "hidden";
    element.style.transition = `height ${transitionDuration} ${transitionType}, opacity ${transitionDuration} ${transitionType}`;

    void element.offsetHeight;

    element.style.height = `${height}px`;
    element.style.opacity = "1";
  };

  const setDefaultHeight = (toggles) => {
    if (!toggles || toggles.length === 0) return;

    toggles.forEach((item) => {
      const answer = item.querySelector(".collapsible-content-item__answer");
      if (!answer) return;

      if (item.getAttribute("data-default-opened") === "true") {
        answer.style.height = `${answer.scrollHeight}px`;
        unlockFocus(answer);
      } else {
        lockFocus(answer);
      }
    });
  };

  const initCollapsibleContent = (section) => {
    if (
      !section ||
      !section.classList.contains("collapsible-content-section")
    ) {
      return;
    }

    const toggles = section.querySelectorAll(".collapsible-content-item");

    setDefaultHeight(toggles);

    const closeOtherItems = (currentItem) => {
      toggles.forEach((item) => {
        if (item !== currentItem) {
          item.classList.remove("active");
          item.removeAttribute("data-default-opened");
          const answer = item.querySelector(
            ".collapsible-content-item__answer"
          );
          slideUp(answer);
          lockFocus(answer);
        }
      });
    };

    const handleClick = (event) => {
      const item = event.currentTarget;

      const answer = item.querySelector(".collapsible-content-item__answer");
      if (!answer) return;

      if (item.classList.contains("active")) {
        slideUp(answer);
        lockFocus(answer);
        item.classList.remove("active");
        item.removeAttribute("data-default-opened");
      } else {
        closeOtherItems(item);
        item.classList.add("active");
        unlockFocus(answer);
        slideDown(answer);
      }
    };

    toggles.forEach((toggle) => {
      toggle.addEventListener("click", handleClick);

      toggle.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          handleClick({ currentTarget: toggle });
        }
      });
    });
  };

  initCollapsibleContent(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initCollapsibleContent(event.target);
  });
})();
